// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer_footerContainer__1fRBV","footerText":"footer_footerText__1ZgG4"};